import { useState } from "react";
import { Box, IconButton, Typography, styled } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import {
  formatPersonalLayerToFormValues,
  useDeletePersonalLayer,
  useUpdatePersonalLayer,
} from "hooks/layerHooks";

import { LayerFormValues, PersonalLayer } from "types/types";

import { StyledDialog } from "components/dialog/StyledDialog";
import { LayerForm } from "./LayerForm";

interface Props {
  layer: PersonalLayer;
  removePersonalLayerParams: (layerId: number) => void;
}

export function LayerActions(props: Props) {
  const { layer, removePersonalLayerParams } = props;
  const formValues = formatPersonalLayerToFormValues(layer);
  const { t } = useTranslation();
  const { mutateAsync: update } = useUpdatePersonalLayer();
  const { mutateAsync: deleteLayer } = useDeletePersonalLayer();
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  async function onSubmit(values: LayerFormValues) {
    setIsDialogOpen(false);
    update(values);
  }

  async function onDelete() {
    deleteLayer(layer.id);
    removePersonalLayerParams(layer.id);
  }

  return (
    <StyledBox>
      <StyledDialog
        isDialogOpen={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
      >
        <Typography variant="h2" component="h2">
          {t("label.addPersonalLayer")}
        </Typography>
        <LayerForm
          isEditing
          onSubmit={onSubmit}
          initialValues={formValues}
          setIsDialogOpen={setIsDialogOpen}
          onDelete={onDelete}
        />
      </StyledDialog>
      <IconButton size="small" onClick={() => setIsDialogOpen(true)}>
        <Edit fontSize="small" />
      </IconButton>
      <IconButton size="small" onClick={onDelete}>
        <Delete fontSize="small" />
      </IconButton>
    </StyledBox>
  );
}

const StyledBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;
